module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/design-tile-images/design-tile-01-c7eb2cdf557d8e9e51b4c4bed834fdbf.jpg";